// The legally required wording for 0 % supplies (Notion "Idea - Stripe VAT" §6),
// keyed by note key and language. CommonJS: shared by server and client.

const NOTE = {
  STANDARD: 'STANDARD',
  REVERSE_CHARGE: 'REVERSE_CHARGE',
  REVERSE_CHARGE_NON_EU_SELLER: 'REVERSE_CHARGE_NON_EU_SELLER',
  EXEMPT_FI: 'EXEMPT_FI',
  EXEMPT_DE: 'EXEMPT_DE',
  EXEMPT_EU: 'EXEMPT_EU',
  OUTSIDE_EU_B2B: 'OUTSIDE_EU_B2B',
  NON_EU_SELLER_NO_EU_VAT: 'NON_EU_SELLER_NO_EU_VAT',
  NON_EU_SELLER_NO_VAT: 'NON_EU_SELLER_NO_VAT',
};

const NOTE_TEXT = {
  REVERSE_CHARGE: {
    fi:
      'Käännetty verovelvollisuus – ostaja on verovelvollinen (AVL 65 §, arvonlisäverodirektiivin 2006/112/EY 196 artikla). ALV 0 %.',
    en:
      'Reverse charge – VAT to be accounted for by the buyer (Article 196 of Council Directive 2006/112/EC). VAT 0 %.',
  },
  REVERSE_CHARGE_NON_EU_SELLER: {
    fi:
      'Käännetty verovelvollisuus – ostaja on verovelvollinen (AVL 9 §). Myyjä ei ole sijoittautunut EU:n arvonlisäveroalueelle. ALV 0 %.',
    en:
      'Reverse charge – VAT to be accounted for by the buyer (Article 196 of Council Directive 2006/112/EC; Finnish VAT Act section 9). Supplier established outside the EU VAT area. VAT 0 %.',
  },
  EXEMPT_FI: {
    fi:
      'Ei sisällä arvonlisäveroa – myyjä ei ole arvonlisäverovelvollinen (vähäinen toiminta, AVL 3 §).',
    en:
      'No VAT – seller is not VAT-registered (small business exemption, Finnish VAT Act section 3).',
  },
  EXEMPT_DE: {
    de: 'Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.',
    en: 'No VAT charged under § 19 UStG small business scheme.',
  },
  EXEMPT_EU: {
    en: 'VAT exempt – small enterprise scheme (Article 284 of Council Directive 2006/112/EC).',
  },
  OUTSIDE_EU_B2B: {
    fi: 'ALV 0 % – palvelun myyntimaa on EU:n ulkopuolella (AVL 65 §).',
    en: 'VAT 0 % – place of supply outside the EU (Article 44 of Council Directive 2006/112/EC).',
  },
  NON_EU_SELLER_NO_EU_VAT: {
    fi:
      'Ei EU:n arvonlisäveroa – myyjä on sijoittautunut EU:n ulkopuolelle (arvonlisäverodirektiivin 2006/112/EY 45 artikla).',
    en:
      "Not subject to EU VAT – supplier established outside the EU (Article 45 of Council Directive 2006/112/EC). Any tax due in the supplier's country is the supplier's responsibility.",
  },
  NON_EU_SELLER_NO_VAT: {
    en: 'No VAT / sales tax applied by the supplier.',
  },
};

const lang = locale =>
  String(locale || 'en')
    .toLowerCase()
    .slice(0, 2);

// The note for a 0 % supply, or null when nothing needs to be printed.
const noteText = (noteKey, locale, { exemptId } = {}) => {
  const texts = NOTE_TEXT[noteKey];
  if (!texts) return null;
  const base = texts[lang(locale)] || texts.en;
  if (noteKey === NOTE.EXEMPT_EU && exemptId) return `${base} ${exemptId}`;
  return base;
};

// 0.255 → "25,5" (fi) / "25.5" (en). Works on the string form to avoid
// floating-point noise such as 0.255 * 100 = 25.500000000000004.
const formatRatePercent = (rate, locale) => {
  const pct = String(Math.round(Number(rate) * 10000) / 100);
  return lang(locale) === 'fi' ? pct.replace('.', ',') : pct;
};

// "ALV 25,5 %" / "VAT 25.5 %" / "MVA 25 %". EU sellers carry label 'VAT',
// which Finnish renders as ALV; non-EU sellers' self-declared labels print as-is.
const rateLabel = ({ rate, label }, locale) => {
  const base = label || 'VAT';
  const shown = base === 'VAT' && lang(locale) === 'fi' ? 'ALV' : base;
  return `${shown} ${formatRatePercent(rate, locale)} %`;
};

module.exports = { NOTE, NOTE_TEXT, noteText, rateLabel, formatRatePercent };
